import React, { useEffect, useRef, useState } from "react";
import { API } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Download, BookOpen, Loader2 } from "lucide-react";

const MANUAL = `${API}/manual`;

export default function HelpCenter() {
  const [manifest, setManifest] = useState(null);
  const iframeRef = useRef(null);

  useEffect(() => {
    fetch(`${MANUAL}/manifest.json`).then((r) => r.json()).then(setManifest).catch(() => setManifest({}));
  }, []);

  const jump = (anchor) => {
    if (iframeRef.current) iframeRef.current.src = `${MANUAL}/manual.html#${anchor}`;
  };

  return (
    <div data-testid="help-center-page">
      <div className="flex flex-wrap items-start justify-between gap-4 mb-6">
        <div>
          <div className="overline text-azx-collection">Data Collection</div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold flex items-center gap-2">
            <BookOpen className="h-6 w-6 text-indigo-600" /> Help Center
          </h1>
          <p className="mt-1 text-sm text-slate-500" data-testid="manual-version">
            Data Collection User Manual{manifest?.version ? ` — ${manifest.version}, updated ${manifest.updated}` : ""}
          </p>
        </div>
        <a href={`${MANUAL}/data-collection-manual.pdf`} target="_blank" rel="noopener noreferrer" download>
          <Button data-testid="download-pdf-btn" className="bg-indigo-600 hover:bg-indigo-700">
            <Download className="mr-2 h-4 w-4" /> Download PDF
          </Button>
        </a>
      </div>

      <div className="grid gap-5 lg:grid-cols-[240px_1fr] items-start">
        <nav className="rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 p-4" data-testid="manual-toc">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-slate-400 mb-2">Contents</div>
          {!manifest ? <Loader2 className="h-4 w-4 animate-spin text-slate-400" />
            : (manifest.toc || []).map((s) => (
              <button key={s.anchor} data-testid={`toc-${s.anchor}`} onClick={() => jump(s.anchor)}
                className="block w-full text-left text-[13px] text-slate-600 dark:text-slate-300 hover:text-indigo-600 py-1">
                {s.title}
              </button>
            ))}
        </nav>

        <div className="rounded-lg border border-slate-200 dark:border-slate-800 overflow-hidden bg-white">
          <iframe ref={iframeRef} title="Data Collection User Manual" data-testid="manual-viewer"
            src={`${MANUAL}/manual.html`} className="w-full" style={{ height: "80vh", border: "0" }} />
        </div>
      </div>
    </div>
  );
}
